import { useBadgeData } from './useBadgeCounts';

/** Pending bulk-request count for the sidebar badge (shared /badge-counts poll). */
export function useBulkRequestCount() {
  return useBadgeData().data?.bulk_requests ?? 0;
}
